import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import Files from 'react-files'

var Config = require('../../../config');
let fileReader;

class ModalFile extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.onFilesChange = this.onFilesChange.bind(this);
		this.onFilesError = this.onFilesError.bind(this);
		this.handleFileRead = this.handleFileRead.bind(this);
		this.filesUpload = this.filesUpload.bind(this);

		this.sendToService = this.sendToService.bind(this);

		this.state = {
			show: false,
			files:[]
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(id){
		this.setState({show:true});
	}

	handleClose(){
		this.setState({show:false, files:[]});
	}

	handleFileRead(e){
    	const content = fileReader.result;
    
    	this.sendToService(content.toString());
  	}

  	readFile(file){
    	fileReader = new FileReader();
    	fileReader.onloadend = this.handleFileRead;
    	fileReader.readAsText(file);
  	}

	onFilesChange(files){
    	this.setState({files:files});
  	}

  	onFilesError(error, file){
    	console.log('error code ' + error.code + ': ' + error.message)
  	}

  	filesUpload(){
  		if(this.state.files.length > 0){
  			Object.keys(this.state.files).forEach((key) => {
		      	const file = this.state.files[key];
		      	this.readFile(file);
		    });
  		}else{
  			swal('Error', 'No se ha seleccionado un archivo', 'error');
  		}
	  		
  	}

  	sendToService(xml){
  		var obj = {
  			id:"SolicitudHemocomponente",
  			version:"3",
  			mensaje:xml
  		}
  		this.props.waiting.handleShow('Cargando...');
  		fetch(Config.default.apiGateway.URL+'BBCoreService/components_petition',{
  			method:'POST',
  			body:JSON.stringify(obj),
  			headers: new Headers({
  				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
  				'Accept'		: 'application/json',
  				'Content-Type'	: 'application/json'
  			})
  		}).then(res => {
  			this.props.waiting.handleClose();
  			if(res.ok){
  				return res.json();
  			}else{
  				res.json().then((msg)=>{
  					swal('Error', msg.ExceptionMessage, 'error');
  				})
  			}
  		}).then(response => {
  			if(response !== undefined){
  				this.props.getList();
  				swal('Correcto', 'Carga de archivo correcta', 'success');
  				this.handleClose();

  			}
  		});
  	}

	render(){
		const {t} = this.props;
		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Carga de datos desde archivo</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
	        				<div className="col-xs-12 col-sm-6">
				        		<div className="files">
							        <Files
							          className='files-dropzone-list'
							          onChange={this.onFilesChange}
							          onError={this.onFilesError}
							          accepts={['.xml']}
							          multiple={false}
							          maxFiles={1}
							          maxFileSize={10000000}
							          minFileSize={0}
							          clickable
							        >
							          Arrastre aqui o de click en el area para cargar el archivo
							        </Files>
							        
							    </div>
							</div>
							<div className="col-xs-12 col-sm-6">
								<div className='files-list'>
						            <ul>
						             	{this.state.files.map((file) =>
							              	<li className='files-list-item' key={file.id}>
							                	<div className='files-list-item-preview'>
							                  		{file.preview.type === 'image'
									                	? <img className='files-list-item-preview-image' src={file.preview.url} />
									                : <div className='files-list-item-preview-extension'>{file.extension}</div>}
							                	</div>
							                	<div className='files-list-item-content'>
								                  	<div className='files-list-item-content-item files-list-item-content-item-1'>{file.name}</div>
								                  	<div className='files-list-item-content-item files-list-item-content-item-2'>{file.sizeReadable}</div>
							                	</div>
							              	</li>
							            )}
						            </ul>
						          </div>
								
							</div>
			        		
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	
		        	<FlatButton primary={true} label={t('content.generics.buttons.submit')}  onClick={this.filesUpload}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		)
	}
}

export default translate('translations')(ModalFile)